module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/issue-144.vue");


//////////////////
// WEBPACK FOOTER
// ./en/contribution/issue.md
// module id = 563
// module chunks = 427